export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "stream_worker.f45b151b.worker.js");
}
